
export const environment = {
  production: true,
  isDebugMode: false,

  APP_MODE: 'md',
  POSTHOG_HOST: 'https://us.posthog.com',
  SYSTEM_AUTO_REFRESH_MINUTES: '30',
  WORKSPACE: 'prod',
  URL_BASE: 'https://lumivraz-api-free.onrender.com',
  APP_VERSION: '1.2.1',
  DEFAULT_PAYMENT_PROVIDER: 'mercadopago',
  PAGARME_PUBLIC_KEY: '',
  MERCADOPAGO_PUBLIC_KEY: 'APP_USR-f88fe6f4-e24a-4650-8b55-efd7ee094572',
  ENVIRONMENT: 'client',
  APP_NAME: 'Centelha',
  APP_URL: 'https://centelha.app.br/',
  ONESIGNAL_APP_ID: '67127e57-ed08-4fef-b574-a06bec96341a',
  GOOGLE_AUTH_CLIENT_ID: '71712447529-s5u2acglt9ip1ren4q8b26oibu3o578m.apps.googleusercontent.com',
  GOOGLE_ADS_CLIENT_NUMBER: '1075459271081134',
  GOOGLE_ADS_SLOT_CODE: '8626406570',
  USE_ADS: true,
  SENTRY_DSN: 'OFF',
  GOOGLE_ANALYTICS_ID: 'G-6149SKCDY5',
  POSTHOG_API_KEY: 'OFF',
};
